"use client";

import { useSyncExternalStore } from "react";
import { Navigation } from "lucide-react";

// Opent de navigatie van de telefoon met het adres van de wedstrijd (B1).
//
// Op een iPhone Apple Kaarten, anders Google Maps: wie een iPhone heeft, heeft
// Apple Kaarten altijd, Google Maps lang niet altijd. De server kan dat niet
// weten, dus die geeft Google Maps mee en de browser wisselt het na het laden.
// TRS heeft geen coördinaten; we geven het adres als zoekterm door.
const isApple = () =>
  /iPhone|iPad|iPod/.test(navigator.userAgent) ||
  // iPadOS doet zich voor als een Mac, maar heeft een touchscreen.
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const geenAbonnement = () => () => {};

export function Routeknop({ zoekterm }: { zoekterm: string }) {
  const apple = useSyncExternalStore(geenAbonnement, isApple, () => false);
  const q = encodeURIComponent(zoekterm);
  const href = apple
    ? `https://maps.apple.com/?daddr=${q}`
    : `https://www.google.com/maps/dir/?api=1&destination=${q}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex h-11 items-center gap-2 rounded-full bg-primary px-5 font-display text-sm font-black uppercase tracking-wide text-primary-foreground transition-colors hover:bg-accent"
    >
      <Navigation className="size-4" aria-hidden />
      Route
    </a>
  );
}
